import React from 'react'
import { List } from '../../../types/components/list'
import { CardStyle } from './style'

export const Card: List = ({ usersArrays }) => {
  return (
    <CardStyle>
      {usersArrays.map((user, index) => (
        <div key={index + 1}>
          <p>Data do Cadastro: {user.CreatedAt}</p>
          <p>Nome: {user.NomeEmpreendedor}</p>
          <p>CPF: {user.CpfEmpreendedor}</p>
          <p>Email: {user.EmailEmpreendedor}</p>
          <p>Celular: {user.CelularEmpreendedor}</p>
          <p>CNPJ: {user.CnpjEmpresa}</p>
        </div>
      ))}
    </CardStyle>
  )
}
